import React, {useRef} from 'react';
import PropTypes from 'prop-types';
import download from 'lib/download';
import {
  addToast,
  Button,
  IconButton,
  FileInput,
  Text,
  useTooltipWithLiveRegion
} from '@albert-io/atomic';

import './upload-csv-btn.scss';

export default class UploadCSVBtn extends React.PureComponent {
  static propTypes = {
    csvHeaderValues: PropTypes.arrayOf(PropTypes.string),
    onUpload: PropTypes.func
  };

  static defaultProps = {
    csvHeaderValues: [],
    onUpload: () => {}
  };

  CSVUploadInputRef = React.createRef();

  popoverTargetRef = React.createRef();

  handleUpload = (e) => {
    const {files} = e.target;
    if (files.length === 0) {
      return;
    }

    const file = files[0];

    const reader = new FileReader();
    reader.onload = (evt) => {
      const fileContent = evt.target.result;
      this.parseItemsFromFile(fileContent);
    };
    reader.readAsText(file, 'UTF-8');
  };

  parseItemsFromFile(fileContent) {
    // Formats columns and rows, trims whitespace, and removes empty cells
    const parsedItems = fileContent
      .replace(/[\n\r]+/g, ',')
      .replace(/\s+/g, '')
      .split(',')
      .filter((item) => item && !this.props.csvHeaderValues.includes(item));

    addToast({
      message: `Successfully imported ${parsedItems.length} items.`,
      title: 'Success!',
      color: 'positive'
    });

    this.props.onUpload(parsedItems.join(';\n'));
  }

  render() {
    return (
      <>
        <FileInput
          accept='text/csv'
          icon='table'
          placeholder='Upload CSV'
          onChange={this.handleUpload}
        />
        <CSVTemplateTooltip />
      </>
    );
  }
}

const CSVTemplateTooltip = () => {
  const csvHeaderValues = ['Email'];
  const tooltipAnchorRef = useRef(null);

  const {
    closeTooltip,
    handleEscape,
    openTooltip,
    tooltipContentRef,
    tooltipProps,
    TooltipWithLiveRegion
  } = useTooltipWithLiveRegion(tooltipAnchorRef);

  const handleClick = () => {
    download(csvHeaderValues.join(','), 'ImportTemplate.csv', 'text/csv');
  };

  return (
    <span className='upload-csv-btn__tooltip-wrapper self-center'>
      <IconButton
        icon={['far', 'question-circle']}
        label='More info'
        size='s'
        onBlur={closeTooltip}
        onClick={openTooltip}
        onKeyDown={handleEscape}
        ref={tooltipAnchorRef}
      />
      <TooltipWithLiveRegion
        {...tooltipProps}
        className='upload-csv-btn__tooltip flex flex-col'
        placement='top'
        theme='light'
      >
        <Text as='p' className='mb-x2 block'>
          Uploading a CSV allows you to easily invite multiple students to your classroom with just
          one file.
        </Text>
        <Text as='p' className='mb-x2 block'>
          Use our template to get started.
        </Text>
        <Button className='w-full' onClick={handleClick} ref={tooltipContentRef}>
          Download CSV template
        </Button>
      </TooltipWithLiveRegion>
    </span>
  );
};
